import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as snackbarActions from "../../../../actions/snackbarActions";
import PageTitle from "../../../Utils/smsTitle";
import { SubHeader } from "../../../../Containers/SubHeader";
import MainSnackbar from "../../../Utils/Snackbar/SmsSnackbar";
import ObGynSidebar from "../../Utils/ObGynSidebar";
import ObGynPatientInfo from "../../Utils/ObGynPatientInfo";
import { useANCBooking } from "./hooks/useANCBooking";
import ANCBookingForm from "./ANCBookingForm";
import ANCBookingDetails from "./ANCBookingDetails";

/**
 * ANCBooking — Page-level container for ANC Registration & Booking
 *
 * This component follows the SmartMed GynAndObs dashboard pattern:
 *   - SubHeader with doctor's name
 *   - Tab navigation via ReusableDoctorTabs
 *   - Container with PatientInformation + content
 *   - Redux-connected snackbar for notifications
 *
 * Uganda MOH HMIS 071 — Antenatal Register Booking Form
 */
const ANCBooking = ({ actions, snackbar, match: { params } }) => {
    // Get current user info
    const user = JSON.parse(sessionStorage.getItem("user"));
    const userObj = !user ? {} : user;
    const token = !userObj.token ? [] : userObj.token;
    const _token = !token[1] ? {} : token[1];
    const doctor_name = `${!_token.first_name ? "" : _token.first_name} ${
        !_token.last_name ? "" : _token.last_name
    }`;

    const { patient_number, visit_id, patient_type } = params;

    // Hook for all ANC booking logic
    const ancBooking = useANCBooking(actions, patient_number, visit_id);
    const { isViewingDetails, existingBooking, gestationalAge, handleEditBooking } = ancBooking;

    const closeSnackbar = () => {
        actions.snackbarActions.hideSnackbar();
    };

    const { openBar, type, message } = snackbar;

    return (
        <div className="journals">
            <PageTitle title="ANC Booking" />
            <SubHeader
                title="OB/GYN"
                subTitle="ANC Registration & Booking"
                doctor_name={doctor_name}
            >
                <div className="header-icon-margin-right-zero">
                    <img
                        src="/images/antenatal-blue.png"
                        className="icon-resize surgery-icon-tabs ante-natal-green"
                        alt="ANC"
                    />
                </div>
            </SubHeader>
            <MainSnackbar
                variant={type}
                open={openBar}
                message={message}
                handleCloseBar={closeSnackbar}
            />
            <ObGynSidebar
                patient_number={patient_number}
                visit_id={visit_id}
                patient_type={patient_type}
            >
                <div style={{padding: '12px 16px'}}>
                    <ObGynPatientInfo patient_number={patient_number} visit_id={visit_id} />
                    <div className="mt-3">
                        {isViewingDetails && existingBooking ? (
                            <ANCBookingDetails
                                existingBooking={existingBooking}
                                currentGestationalAge={gestationalAge}
                                onEditBooking={handleEditBooking}
                            />
                        ) : (
                            <ANCBookingForm {...ancBooking} />
                        )}
                    </div>
                </div>
            </ObGynSidebar>
        </div>
    );
};

function mapStateToProps(state) {
    return {
        snackbar: state.snackbar,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: {
            snackbarActions: bindActionCreators(snackbarActions, dispatch),
        },
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(ANCBooking);
